import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow } from '@angular/material/table';
import { TooltipDetalleCoberturaComponent } from '../tooltip-detalle-cobertura/tooltip-detalle-cobertura.component';
import { MatDialog } from '@angular/material/dialog';
import { Cobertura, ConsultaSiniestroOutput, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { skipWhile, Subscription } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { MatPaginator } from '@angular/material/paginator';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-detalle-tabla-coberturas-siniestro',
    templateUrl: './detalle-tabla-coberturas-siniestro.component.html',
    styleUrls: ['./detalle-tabla-coberturas-siniestro.component.scss'],
    imports: [NgClass, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, MatPaginator]
})
export class DetalleTablaCoberturasSiniestroComponent implements OnInit, OnDestroy {

  @ViewChild(MatPaginator) paginator: MatPaginator;

  public muestraGrid: boolean = false;
  public datosCoberturas: MatTableDataSource<any> = new MatTableDataSource<Cobertura>([]);

  // Tabla Secciones
  public tamanoResultados: number = 0;
  public selectCoberturasDatos = null;
  public selectedCoberturaRowIndex: number | null = null;

  public detalleComplementoSiniestro: ConsultaSiniestroOutput;
  public siniestroCompleto: SiniestroDet;
  public listaObservables: Array<Subscription> = [];
  public screenSize: string = '';
  public displayColumns = ['ClaveCobertura', 'Descripcion', 'Deducible', 'SumaAsegurada', 'EstatusSiniestro', 'Ver'];

  public tooltipCobertura = TooltipDetalleCoberturaComponent;

  constructor(
    private dialogRef: MatDialog,
    private store: Store<AppState>,
    private procesosComplementoService: ProcesosComunesComplementoService,
  ) { 
    this.tamanoPantalla();
  }

  ngOnInit(): void {
    this.onReduxChange();
  }

  ngOnDestroy(): void {
    this.listaObservables.forEach(obs => obs.unsubscribe());
  }

  onReduxChange() {
    const complementoWeb = this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)).subscribe({
      next: (value: ConsultaSiniestroOutput) => {
        this.detalleComplementoSiniestro = value;
        this.siniestroCompleto = value.Siniestro[0];

        this.datosCoberturas = new MatTableDataSource(this.detalleComplementoSiniestro.Coberturas);
        setTimeout(() => {
          this.datosCoberturas.paginator = this.paginator;
        }, 100);
      },
    })
    this.listaObservables.push(complementoWeb);
  }

  tamanoPantalla() {
    const subScreen = this.procesosComplementoService.screenSize$.subscribe(size => {
      this.screenSize = size;
    });
    this.listaObservables.push(subScreen);
  }

  SelectRow(row, tipo: 'COBERTURA') {
    if (tipo === 'COBERTURA') {
      this.selectedCoberturaRowIndex = row.cve_coberturak;
      this.selectCoberturasDatos = row;
    }
  }

  abrirModalDetalleCobertura(elemento: Cobertura) {
    const dialog = this.dialogRef.open(TooltipDetalleCoberturaComponent, {
      width: '400px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { cobertura: elemento },
    }).afterClosed().subscribe(data => {

    });
  }

}
